var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "square-arrow-right",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.553223,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.553223,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 7.5,
    stroke: "#DFE0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4816 25.3331L24.7483 30.5998C24.9911 30.8512 25.1255 31.188 25.1225 31.5376C25.1195 31.8872 24.9792 32.2216 24.732 32.4689C24.4848 32.7161 24.1504 32.8563 23.8008 32.8593C23.4512 32.8624 23.1144 32.728 22.8629 32.4851L15.3203 24.9424C15.196 24.8189 15.0974 24.672 15.0301 24.5102C14.9629 24.3485 14.9282 24.175 14.9282 23.9998C14.9282 23.8245 14.9629 23.6511 15.0301 23.4893C15.0974 23.3275 15.196 23.1806 15.3203 23.0571L22.8629 15.5144C23.1155 15.2776 23.4504 15.1482 23.7966 15.1539C24.1429 15.1595 24.4733 15.2996 24.7181 15.5446C24.9629 15.7895 25.1028 16.1201 25.1082 16.4663C25.1135 16.8126 24.984 17.1473 24.7469 17.3998L19.4803 22.6664L32.2616 22.6664C32.6152 22.6664 32.9544 22.8069 33.2044 23.0569C33.4545 23.307 33.5949 23.6461 33.5949 23.9998C33.5949 24.3534 33.4545 24.6925 33.2044 24.9426C32.9544 25.1926 32.6152 25.3331 32.2616 25.3331L19.4816 25.3331Z",
    fill: "#0B2640"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareArrowRight);
export default __webpack_public_path__ + "static/media/square-arrow-right.f3599fc57e1414ee7a77b5e30d229c1d.svg";
export { ForwardRef as ReactComponent };